// extracted by mini-css-extract-plugin
export var card = "_77-1";
export var container = "_77-0";